const Gallery = () => <div />; // never used

Gallery.componentName = 'Gallery';

export default Gallery;
